import { ISearchSuggestionProps } from '@1js/search-types';
import { IO365ShellShim } from '@suiteux/suiteux-shell';
import React from 'react';
import { ClassNames } from '../../shared/icon-font/icon-font-classes.utility';
import { IconFontType } from '../../shared/icon-font/icon-font-type.enum';
import { SearchInstrumentationService, SearchResultElementId, SearchResultType } from '../search-instrumentation.service';
import { SearchSuggestionCompoundButtonComponent } from './search-suggestion-components/search-suggestion-compoundButton.component';

interface LearningProps extends ISearchSuggestionProps {
    readonly ariaLabel: string;
    readonly isPwa: boolean;
    readonly isDarkMode: boolean;
    readonly onClick: () => void;
    readonly puid: string;
    readonly searchInstrumentationService: SearchInstrumentationService;
    readonly shellShim: IO365ShellShim;
    readonly title: string;
    readonly hideLearningSuggestions: () => void;
}

export class LearningSearchSuggestionComponent extends React.Component<LearningProps> {

    public readonly handleClick = () => (e: React.MouseEvent | React.KeyboardEvent) => {
        e.preventDefault();
        this.props.onClick();
        this.setLeanringState();
        this.props.searchInstrumentationService.logSearchClickEvent(
                                                    SearchResultType.Learning,
                                                    SearchResultElementId.Learning /* Element ID */,
                                                    false /* PageNav */,
                                                    SearchResultType.LearningPrimary,
                                                    this.props.title
                                                );
    }

    public readonly handleRemoveLearningClick = () => (e: any) => {
        e.preventDefault();

        const learningProvider: HTMLElement = document.getElementById('learning');
        learningProvider.style.display = 'none';
        this.props.shellShim.Search.FocusSearchBox();

        this.setLeanringState();

        this.props.searchInstrumentationService.logSearchClickEvent(
            SearchResultType.Learning,
            SearchResultElementId.Learning /* Element ID */,
            false /* PageNav */,
            SearchResultType.LearningSecondary,
            this.props.title
        );
    }

    public render() {
        const iconClass = ClassNames.FluentIconCssClass;
        const iconSVGClass = ClassNames.SvgIconCssClass;
        return (
            <SearchSuggestionCompoundButtonComponent
                title={this.props.title}
                handleClick={this.handleClick()}
                icon={iconSVGClass + ' ' +
                      iconClass + ' ' +
                      ' ms-Icon--Lightbulb ms-ohp-Icon--learning--lightBulb' +
                      (this.props.isDarkMode && this.props.isPwa ? ' ms-ohp-Icon--see-more--darkMode' : ' ms-ohp-Icon--see-more')}
                description=''
                secondaryButtonProps={{icon: iconSVGClass + ' ' + iconClass + ' ' + ClassNames.getCssClass(IconFontType.X) +
                                      (this.props.isDarkMode && this.props.isPwa ? ' ms-ohp-Icon--learning--cancelButton--darkMode' : ' ms-ohp-Icon--learning--cancelButton'),
                                      onClick: this.handleRemoveLearningClick(),
                                      ariaLabel: this.props.ariaLabel}}
                style={this.props.isDarkMode && this.props.isPwa ? 'search-compound-button-container--see-more--darkMode' : 'search-compound-button-container--see-more'}
                target='_blank'
                isDarkMode={this.props.isDarkMode}
                isPwa={this.props.isPwa}
            />
        );
    }

    private setLeanringState() {
        const learningStateObject = localStorage.getItem('OfficeDotComConsumerLearningStateObject');
        let learningState: Array<string> = [];

        if (learningStateObject) {
            learningState = JSON.parse(learningStateObject);
        }

        learningState.push(this.props.puid);
        localStorage.setItem('OfficeDotComConsumerLearningStateObject', JSON.stringify(learningState));

        this.props.hideLearningSuggestions();
    }
}
